'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { useAnalyticsSessionId } from '~/app/_ui/shared/AnalyticsSessionIdProvider/AnalyticsSessionIdProvider';

export function SegmentPageSyncer() {
  const analyticsSessionId = useAnalyticsSessionId();
  const pathname = usePathname();
  useEffect(() => {
    window.analytics?.page({
      sessionId: analyticsSessionId,
    });
  }, [pathname, analyticsSessionId]);

  return null;
}
